export default __webpack_public_path__ + "static/media/3-2-areaOfConcerns.67282573.png";